// extracted by mini-css-extract-plugin
export default {"principalButton":"Button_principalButton__vx+-U"};